'use client'

import type { ReactNode } from 'react'

export const FieldModalControls = ({ children }: { children: ReactNode }) => {
  return <div className="p-8 flex-1">{children} </div>
}
